import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, Filter, Clock, Brain, Users, DollarSign } from 'lucide-react';
export function DelegateSlide() {
  const [reps, setReps] = useState(3);
  const salary = 65000;
  const benefits = 0.25;
  const currentCost = reps * salary * (1 + benefits);
  const agentCost = 1247 * 12 * Math.ceil(reps / 3);
  const setupCost = 2000;
  const letLoisCost = agentCost + setupCost;
  const savings = currentCost - letLoisCost;
  return <section id="delegate" className="min-h-screen bg-dark-section py-24 px-4 flex flex-col justify-center" data-id="element-264">
      <div className="max-w-7xl mx-auto w-full" data-id="element-265">
        <div className="text-center mb-16" data-id="element-266">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold mb-4" data-id="element-267">
            AI Agents for Sales
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-primary font-medium" data-id="element-268">
            The Cutting Edge
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-269">
          {/* Features Side */}
          <div className="space-y-6" data-id="element-270">
            <div className="bg-gradient-to-br from-primary/20 to-blue-900/10 p-8 rounded-3xl border border-primary/20" data-id="element-271">
              <h3 className="text-2xl font-bold mb-6 flex items-center" data-id="element-272">
                <Brain className="mr-3 text-primary" size={32} data-id="element-273" />
                What Delegate Does
              </h3>
              <ul className="space-y-4" data-id="element-274">
                {['AI agents automatically call and text qualified leads', 'Screen leads, schedule appointments, handle objections', 'Available 24/7 — no sick days, vacations, or lunch breaks', 'Learns from conversations, improves over time', 'Reactivates old leads sitting in your CRM', 'Seamlessly hands off to human team when needed'].map((item, i) => <li key={i} className="flex items-start" data-id="element-275">
                    <div className="mt-1 mr-3 min-w-[20px]" data-id="element-276">
                      <div className="w-2 h-2 bg-primary rounded-full" data-id="element-277" />
                    </div>
                    <span className="text-lg text-white/90" data-id="element-278">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Calculator */}
          <div className="bg-dark-card rounded-2xl p-8 border border-white/10" data-id="element-279">
            <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-280">
              Sales Team Replacement Calculator
            </h3>

            <div className="flex flex-col items-center mb-12" data-id="element-281">
              <label className="text-lg mb-4 text-text-muted" data-id="element-282">
                Full-time sales reps:
              </label>
              <div className="flex items-center space-x-6" data-id="element-283">
                <button onClick={() => setReps(Math.max(1, reps - 1))} className="w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-2xl font-bold transition-colors" data-id="element-284">
                  -
                </button>
                <span className="text-5xl font-bold text-white w-20 text-center" data-id="element-285">
                  {reps}
                </span>
                <button onClick={() => setReps(reps + 1)} className="w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-2xl font-bold transition-colors" data-id="element-286">
                  +
                </button>
              </div>
            </div>

            <div className="space-y-6" data-id="element-287">
              <div className="flex justify-between items-center p-4 bg-red-500/10 rounded-xl border border-red-500/20" data-id="element-288">
                <span className="text-red-400 font-bold uppercase tracking-wider" data-id="element-289">
                  Current Cost
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-290">
                  ${currentCost.toLocaleString()}
                </span>
              </div>

              <div className="flex justify-between items-center p-4 bg-green-500/10 rounded-xl border border-green-500/20" data-id="element-291">
                <span className="text-green-400 font-bold uppercase tracking-wider" data-id="element-292">
                  LetLois Cost
                </span>
                <span className="text-2xl font-bold text-white" data-id="element-293">
                  ${letLoisCost.toLocaleString()}
                </span>
              </div>

              <div className="pt-6 border-t border-white/10 text-center" data-id="element-294">
                <p className="text-sm text-text-muted mb-2 uppercase tracking-widest" data-id="element-295">
                  Annual Savings
                </p>
                <p className="text-5xl md:text-6xl font-bold text-primary" data-id="element-296">
                  ${savings.toLocaleString()}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-297">
          {[{
          label: 'Replace Sales Rep',
          value: '$65K/yr'
        }, {
          label: 'Call Volume',
          value: '10x'
        }, {
          label: 'Scheduling Success',
          value: '60-80%'
        }, {
          label: 'Starting Cost',
          value: '$1,247/mo'
        }].map((stat, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4 + i * 0.1
        }} className="text-center p-6 bg-white/5 rounded-xl border border-white/5" data-id="element-298">
              <p className="text-xs text-text-muted uppercase tracking-wider mb-2" data-id="element-299">
                {stat.label}
              </p>
              <p className="text-2xl font-bold text-white" data-id="element-300">{stat.value}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}